// extracted by mini-css-extract-plugin
module.exports = {"card":"user-item_card__1MNwp","body":"user-item_body__1Ejl0","avatar":"user-item_avatar__36-oZ"};